import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { MusicalWorkLinkView } from "./MusicalWorkLinkView";
import { MusicalWorkLinkViewStore } from "../../store/MusicalWorkLinkViewStore";
import { useStore } from "../../../../hooks";

export const MusicalWorkLinkViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/musicalWorkLink/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new MusicalWorkLinkViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <MusicalWorkLinkView musicalWorkLinkViewStore={store} />
      </PageLayout>
    </div>
  );
});
